var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"app__container"},[_c('webgl-scene',{staticClass:"app__scene"}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }